module.exports = __webpack_public_path__ + "static/media/Google-icon.5899ba97.png";